import React from "react";
import Navigation from "../Navigation/Navigation";

const Header = () => (
  <header className="App-header">
    <h1>らくらく連絡網メルマガ配信停止フォーム</h1>
    <Navigation />
  </header>
);

export default Header;
